import React from 'react';
function Fill({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3 11V6a2 2 0 012-2h13a2 2 0 012 2v12a2 2 0 01-2 2h-4M7.5 20h-4v-4M4 19.5L7.5 16"
      />
      <g>
        <path strokeLinecap="round" strokeLinejoin="round" d="M10 9.5h4v4M13.5 10L10 13.5" />
      </g>
    </svg>
  );
}

export default Fill;
